import { useAppSelector } from '@/hooks';

export const useCashbackIsSelected = () => {
  const cashbackVoucherItem = useAppSelector((state) => state.customProducs?.serverProductSelection?.cashbackVoucher);
  return cashbackVoucherItem?.amount > 0;
};
